import { ArrowLeftOutlined } from '@ant-design/icons';
import { Drawer } from 'antd';
import Flex from 'components/shared-components/Flex';
import { NAV_TYPE_SIDE } from 'constants/ThemeConstant';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { connect } from 'react-redux';
import { onMobileNavToggle } from 'redux/actions/Theme';

import Logo from './Logo';
import MenuContent from './MenuContent';

export const MobileNav = ({
  sideNavTheme,
  mobileNav,
  onMobileNavToggle,
  routeInfo,
  hideGroupTitle,
  getSideMenuList,
  localization = true,
}) => {
  const props = {
    sideNavTheme,
    routeInfo,
    hideGroupTitle,
    localization,
    getSideMenuList,
  };

  const onClose = () => {
    onMobileNavToggle(false);
  };

  return (
    <Drawer
      placement="left"
      closable={false}
      onClose={onClose}
      visible={mobileNav}
      bodyStyle={{ padding: 5 }}
    >
      <Flex flexDirection="column" className="h-100">
        <Flex justifyContent="between" alignItems="center">
          <Logo mobileLogo={true} />
          <div className="nav-close" onClick={() => onClose()}>
            <ArrowLeftOutlined />
          </div>
        </Flex>
        <div className="mobile-nav-menu">
          <Scrollbars autoHide>
            <MenuContent
              type={NAV_TYPE_SIDE}
              {...props}
              newSideMenuItems={props?.getSideMenuList?.data?.data || []}
            />
          </Scrollbars>
        </div>
      </Flex>
    </Drawer>
  );
};

const mapStateToProps = ({ theme, sidemenu }) => {
  const { navCollapsed, sideNavTheme, mobileNav } = theme;
  return { navCollapsed, sideNavTheme, mobileNav, ...sidemenu };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MobileNav);
